import React, {useState} from "react";

import {useHistory} from "react-router-dom";

import './style.scss';
import logo from '@common-images/logo.svg';

import {setPathForRouter} from "@common-helpers/set-rout-path";
import {faceBookPixel} from "@common-helpers/face-book-pixel";
import {tiktokPixel} from "@common-helpers/tik-tok-pixel"

import {Button} from '@common-ui/btn';
import {Modal} from '@common-components/modal';

import axios from 'axios';

export const MainPage = ({nextRout, nextPageId}) =>
{
    const
        history = useHistory(),
        nextPage = () => {
            faceBookPixel('track', 'Lead', {'external_id': localStorage.getItem('click_id')})
            tiktokPixel('ViewContent')

            setPathForRouter(nextRout, nextPageId, false, history)
        },

        [modalOpen, setModalOpen] = useState(false),
        [modalContent, setModalContent] = useState(false),
        openModalHandler = async (event) => {
            event.preventDefault();

            const {data} = await axios.get(event.target.href, {
                headers: {
                    'x-requested-with': 'XMLHttpRequest',
                },
                responseType: 'html',
            });

            setModalOpen(true);
            setModalContent(data);
            document.querySelector('.component-scroll-wrapper').scrollTop = 0;
            document.querySelector('.modal_open').scrollTop = 0;
        }
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <div className={'content main'}>
            <button
                className={`burger ${menuOpen ? "burger--open" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            {/* Dropdown menu */}
            {menuOpen && (
                <nav className="burger-menu">
                    <ul>
                        <li>
                            <a href="/" onClick={() => setMenuOpen(false)}>
                                Home
                            </a>
                        </li>
                        <li>
                            <a
                                href="/about"
                                onClick={() => setMenuOpen(false)}
                            >
                                About us
                            </a>
                        </li>
                    </ul>
                </nav>
            )}
            <img className={'main__logo'} src={logo} alt={'Easy Fitness'}/>
            <div className={'main__content'}>
                <h1 className={'main__title'}>CHOOSE YOUR GOAL</h1>
                <p className={'main__subtitle'}>Complete short survey and get personal recommendations.</p>
                <div className={'main__buttons-row'}>
                    <Button
                        onClick={nextPage}
                        direction={'forward'}
                        theme={'slim pink'}
                    >
                        Lose weight
                    </Button>
                    <Button
                        onClick={nextPage}
                        direction={'forward'}
                        theme={'slim yellow'}
                    >
                        Get healthier
                    </Button>
                </div>
            </div>
            <div className={'main__footer'}>By using this site, you consent to the use of cookies to help us make it better and you are also agree to our <a href="/privacy" onClick={openModalHandler}>privacy policy</a> and <a href="/terms" onClick={openModalHandler}>service rules</a>.</div>
            <Modal
                isOpen={modalOpen}
                openHandler={setModalOpen}
                theme={'big'}
            >
                {modalContent}
            </Modal>
        </div>
    )
}
